<template>
    <div>
        <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                               :titleLabel="title"
                               :parentScreen="parentScreen">
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label"
                       for="zipCode">{{$t('profile.label.postal_code')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.zipCode'].$model"
                           id="zipCode"
                           name="zipCode"
                           required
                           maxlength="7"
                           @blur="searchZipCode('amsCustomerDetail.zipCode','amsCustomerDetail.prefecture','amsCustomerDetail.city')"
                           v-convert-fullwidth-to-halfwidth
                    >
                    <error-messages-block :field="$v.input['amsCustomerDetail.zipCode']">
                        <template #required>
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.postal_code')}) }}
                        </template>
                        <template #customerNumberValidation>
                            {{ $t('profile.error.invalid_number') }}
                        </template>
                    </error-messages-block>
                </div>
                <label class="control-label col-md-3 col-form-label">
                    <a :href="hrefPostalCodeReference" target="_blank">
                        {{$t('profile.href.postal_code_reference')}}
                    </a>
                </label>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label"
                       for="prefecture">{{$t('profile.label.perfecture')}}</label>
                <div class="col-md-6">
                    <select class="form-control"
                            v-model="$v.input['amsCustomerDetail.prefecture'].$model"
                            required
                            id="prefecture"
                            name="prefecture"
                            @input="handleForceNewEvent"
                    >
                        <option v-for="item in listPrefecture" :key="item.key" :value="item.value">
                            {{item.value}}
                        </option>
                    </select>
                    <error-messages-block :field="$v.input['amsCustomerDetail.prefecture']">
                        <template #required>
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.perfecture')}) }}
                        </template>
                      <template #prefectureIsNotDefaultValue>
                        {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.perfecture')}) }}
                      </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label"
                       for="city">{{$t('profile.label.city')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.city'].$model"
                           id="city"
                           name="city"
                           required
                           maxlength="100"
                           v-convert-halfwidth-to-fullwidth
                           @keyup="checkNeedUpdateForceNews($v.input['amsCustomerDetail.city'].$model, 'city')"
                    >
                    <error-messages-block :field="$v.input['amsCustomerDetail.city']">
                        <template #required>
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.city')}) }}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label"
                       for="section">{{$t('profile.label.section')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.section'].$model"
                           id="section"
                           name="section"
                           required
                           maxlength="50"
                           v-convert-halfwidth-to-fullwidth
                           @keyup="checkNeedUpdateForceNews($v.input['amsCustomerDetail.section'].$model, 'section')"
                    >
                    <error-messages-block :field="$v.input['amsCustomerDetail.section']">
                        <template #required>
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.section')}) }}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="buildingName">{{$t('profile.label.building_name')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.buildingName'].$model"
                           id="buildingName"
                           name="buildingName"
                           maxlength="50"
                           v-convert-halfwidth-to-fullwidth
                           @keyup="checkNeedUpdateForceNews($v.input['amsCustomerDetail.buildingName'].$model, 'buildingName')"
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label">{{$t('profile.label.upload.title')}}</label>
                <div class="col-md-6">
                    <FileInput v-model="$v.fileCustomerAddress1.$model" name="fileCustomerAddress1"
                               @onChangeFileInput="handleChangeFileInput">
                    </FileInput>
                    <error-messages-block :field="$v.fileCustomerAddress1">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerAddress2.$model" name="fileCustomerAddress2"
                               @onChangeFileInput="handleChangeFileInput">
                    </FileInput>
                    <error-messages-block :field="$v.fileCustomerAddress2">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerAddress3.$model" name="fileCustomerAddress3"
                               @onChangeFileInput="handleChangeFileInput">
                    </FileInput>
                    <error-messages-block :field="$v.fileCustomerAddress3">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <template v-if="isCorporation">
                <div class="form-group row">
                    <div :class="this.isParentScreenForceNew ? 'col-md-9': 'col-md-12' ">
                        <div class="alert alert-warning">
                            <div v-html="$t('profile.label.address.corporation.after_upload.1.new',{param :SUPPORT_DOCUMENT_URL})"/>
                            {{$t('profile.label.address.corporation.after_upload.2')}}
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="form-group row">
                    <div :class="this.isParentScreenForceNew ? 'col-md-9': 'col-md-12' ">
                        <div class="alert alert-warning">
                            <div>{{$t('profile.label.address.invidual.after_upload.1')}}</div>
                            <div v-html="$t('profile.label.address.invidual.after_upload.2.new',{ param : SUPPORT_DOCUMENT_URL})"></div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="this.isParentScreenEditProfile">
                <div class="form-action">
                    <button class="btn btn-sm btn-submit btn-success mr-2"
                            :disabled="isDisabledButtonSubmit && isInvalidFile"
                            :type="this.getButtonType()">
                        {{$t('profile.button.verify')}}
                    </button>
                    <button class="btn btn-default btn-cancel btn-sm"
                            type="button"
                            @click="reverseInput">
                        {{$t('profile.button.cancel')}}
                    </button>
                </div>
            </template>
        </ForceNewsBlockWrapper>
    </div>
</template>

<script>
    /**
     * @author HungNS
     */

    import {createNamespacedHelpers} from 'vuex';
    import formMixin from '@/common/mixins/form';
    import forceNewUtil from "@/common/mixins/forceNewUtil";
    import {required, requiredUnless} from 'vuelidate/lib/validators';
    import IConstants from "../../../../common/constants/IConstants";
    import {containOnlySpace, customerNumberValidation, prefectureIsNotDefaultValue} from '@/common/helpers/validation'


    const {mapGetters: mapForceNewsGetters} = createNamespacedHelpers("forceNews");
    export default {
        name: "UpdateCustomerAddress",
        props: {
          displayForms: {
            type: String,
            required: false,
            default: ''
          },

        },
        mixins: [formMixin, forceNewUtil],
        data: function () {
            const {IConstants} = this;
            const hrefPostalCodeReference = IConstants.HREF_POSTAL_CODE_REFERENCE;
            return {
                hrefPostalCodeReference,
                fileCustomerAddress1: null,
                fileCustomerAddress2: null,
                fileCustomerAddress3: null
            }
        },
        mounted() {
            this.originData = {
                zipCode: this.input['amsCustomerDetail.zipCode'],
                prefecture: this.input['amsCustomerDetail.prefecture'],
                city: this.input['amsCustomerDetail.city'],
                section: this.input['amsCustomerDetail.section'],
                buildingName: this.input['amsCustomerDetail.buildingName']
            }
        },
        computed: {
            isCorporation() {
                return this.$store.state[this.namespace].isCorporation
            },
            SUPPORT_DOCUMENT_URL() {
                return this.$store.state[this.namespace].SUPPORT_DOCUMENT_URL
            },
            title() {
                let result = '';
                if (this.isCorporation) {
                    result = this.$t('profile.corp.label.address');
                }
                else {
                    result = this.$t('profile.label.address');
                }
                return result;
            },
            fileUploadExt() {
                return this.$store.state.header.headerInfo.fileUploadExt
            },
            fileTypeExtension() {
                return this.fileUploadExt.toUpperCase();
            },

            // why put it as computed: It is not possible to dynamically pass parameters to Vue mixins, so we work around
            displayFormCode() {
                return IConstants.FORCE_NEW_DISPLAY_FORM_CODE.ADDRESS;
            },
            isInvalidFile(){
              const {$v} = this;
              return $v.$anyError || (this.fileCustomerAddress1 === null && this.fileCustomerAddress2 === null && this.fileCustomerAddress3 === null);
            },
            ...mapForceNewsGetters(['listPrefecture']),

        },
        validations() {
            const initValidData = this.getInitFileValidation({...this.$data}, ['hrefPostalCodeReference'], undefined, true);
            return {
                input: {
                    'amsCustomerDetail.zipCode': {
                      required: requiredUnless(containOnlySpace),
                      customerNumberValidation
                    },
                    'amsCustomerDetail.prefecture': {
                        required,
                        prefectureIsNotDefaultValue
                    },
                    'amsCustomerDetail.city': {
                        required,
                    },
                    'amsCustomerDetail.section': {
                        required,
                    },
                    'amsCustomerDetail.buildingName': {},
                },
                ...initValidData
            }
        },
        methods: {
            searchZipCode: function (zipCodeKey, prefectureKey, cityKey) {
                let zipCode = this.input[zipCodeKey];
                const params = {
                        'zipCode': zipCode
                };
                let self = this;
                this.$service.getService("forceNews")
                    .searchZipCode(params)
                    .then( response => {
                        if (response.prefecture) self.input[prefectureKey] = response.prefecture;
                        if (response.prefecture && response.section) self.input[cityKey] = response.city + '　' + response.section;
                        self.$v.$touch();
                    
                        if (self.isParentScreenForceNew) {
                            self.checkNeedUpdateForceNews(self.input[zipCodeKey], 'zipCode');
                            self.checkNeedUpdateForceNews(self.input[prefectureKey], 'prefecture');
                            self.checkNeedUpdateForceNews(self.input[cityKey], 'city');
                        }
                    })
            },
            
            checkNeedUpdateForceNews(val, elName) {
                if (!this.isParentScreenForceNew) {
                    return;
                }
                
                if (this.originData[elName] !== val) {
                    this.$v.$touch();
                    this.handleForceNewEvent();
                }
            }
        },
    }
</script>

<style scoped>

</style>
